import { FetchProxy } from "intraactive-sdk-helper";
import { sdkContainerInstance } from "../global/Container";
import { IEnvironment } from "../interfaces/IEnvironment";
import { Environment } from "./Environment";

export default class PushService {

  public static registerDevice(environment: IEnvironment, tenant: string, pushToken: string, platform: "android" | "ios"): Promise<void> {
    return new Promise((resolve) => {
      const apiURL = `${Environment.getEnvironmentForNotificationApi(environment)}/api/${tenant}/push-devices`;
      const body: string = JSON.stringify({
        pushToken,
        platform
      });
      new FetchProxy(apiURL, { method: "POST", body: body})
      .withContainer(sdkContainerInstance)
      .fetch()
      .then(function (response) {
        if (!response.ok) {
          throw (response.status);
        } else {
          resolve();
        }
      }).catch((error) => {
        console.log(error);
      });
    });
  }
}